import { connect } from "react-redux";
import { Action, Dispatch } from "redux";

import {
  applicantIdStartExamAction,
  applicantIdPasswordAction,
  applicantIdSigninAction,
} from "../../../actions";
import { RootState } from "../../../reducers";
import ExamEntranceId from "./ExamEntranceId";

const mapStateToProps = (state: RootState) => ({
  pageLanguage: state.intl.locale,
  loading: Boolean(state.ajax.submitting),
  initial: state.applicant.initialId,
  error: state.applicant.error,
  examUrlToken: state.applicant.idExamUrlToken,
  passwordRequired: state.applicant.idExamPasswordRequired,
  passwordInitialized: state.applicant.idExamPasswordInitialized,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  sendId: (token: string, id: string) => {
    dispatch(applicantIdStartExamAction.request(token, { id }));
  },
  setPassword: (token: string, params: {}) => {
    dispatch(applicantIdPasswordAction.request(token, params));
  },
  signin: (token: string, params: {}) => {
    dispatch(applicantIdSigninAction.request(token, params));
  },
});

/**
 * Wrapped component
 */
const wrappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExamEntranceId);

export default wrappedComponent;
